import { useHistory } from '@fs/zion-router'
import { Button, Row, TextField } from '@fs/zion-ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { navigationQueryParams } from '../useMessagesListController'
import { useQueryParams } from '../../../../util/UrlUtil'

export default function CompactMessagesListTableFilters({ queueState, queueCachesState, queueActions, filterRef }) {
  const [filterInput, setFilterInput] = useState(queueState.query || '')
  const { t } = useTranslation()
  const queryParams = useQueryParams()
  const history = useHistory()

  const handleApplyFilter = () => {
    const trimmedInput = filterInput.trim()
    const matchingIds =
      trimmedInput?.length >= 3
        ? Object.entries(queueCachesState.usersCache)
            .filter(
              ([, contributorObj]) =>
                typeof contributorObj?.contactName === 'string' &&
                contributorObj?.contactName.toLowerCase().includes(trimmedInput.toLowerCase())
            )
            .map(([id]) => id)
        : []
    queueActions.setQueueState((prevState) => ({
      ...prevState,
      query: trimmedInput + matchingIds.map((id) => ` OR ${id}`),
      queuePageIndex: 0,
    }))
    history.replace({
      search: navigationQueryParams({
        queuePageIndex: 0,
        personId: queryParams.get('personId'),
        treeCategories: queryParams.get('treeCategories'),
      }),
    })
  }

  const handleClearFilter = () => {
    setFilterInput('')
    queueActions.setQueueState((prevState) => ({
      ...prevState,
      query: '',
    }))
  }

  return (
    <Row>
      <TextField
        ref={filterRef}
        value={filterInput}
        onChange={(e) => setFilterInput(e.target.value)}
        onClear={handleClearFilter}
        placeholder={t('queues.filterBy', 'Filter all fields')}
        clearable
        dense
        onEnterKey={handleApplyFilter}
      />
      <Button type="button" onClick={handleApplyFilter}>
        {t('queues.applyFilter', 'Apply Filter')}
      </Button>
    </Row>
  )
}
